import React, { useEffect } from 'react';
import css from './index.module.scss';
import classNames from 'classnames';
import { Tabs, Tab, Divider, Button } from '@material-ui/core';
import noImg from '../../assets/no-itm.png';
import { useNavigate, useLocation } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
import { Redux, Slices } from 'spwa-ui-library';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper.js';
import BackButton from '../../components/BackButton';
import { MdKeyboardArrowLeft } from '@react-icons/all-files/md/MdKeyboardArrowLeft';
const { selectDesktop } = Slices.appSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectProductEntities, getProductInfo } = Slices.productSlice;
const {
  selectCountryValidations,
  getDecimalPoints,
  getVariantConfig,
  getClusterId,
} = Slices.configSlice;
const { addProductToCustomize, increaseQtyByN } = Slices.tempCartSlice;
const { selectDefaultAddress } = Slices.addressSlice;

const { useSelector, useDispatch } = Redux;

function DealsStepper({
  steps,
  title,
  description,
  price,
  oldLocation,
  mainProductId,
  currentStepperId,
  setCurrentStepperId,
  setShowBundleGroupDialog,
}) {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDesktop = useSelector(selectDesktop);
  const decimalPoints = useSelector(getDecimalPoints);
  const [isSticky, setIsSticky] = React.useState(false);
  const tempCart = useSelector((state) => state.tempCart);
  const cart = useSelector((state) => state.cart);
  const [tabIndex, setTabIndex] = React.useState(0);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const productsMap = useSelector(selectProductEntities);
  const variationConfig = useSelector(getVariantConfig);
  const clusterId = useSelector(getClusterId);
  const locationSearch = new URLSearchParams(location.search);

  const address = useSelector(selectDefaultAddress);

  let currentVariantInfo = productsMap[mainProductId]?.items?.find((item) => {
    let itemInfo;
    if (!item?.id) {
      itemInfo = productsMap[item];
    } else {
      itemInfo = item;
    }

    return (
      itemInfo?.id == locationSearch.get('option') ||
      itemInfo?.sel1Value == locationSearch.get('option')
    );
  });

  if (!currentVariantInfo?.id) {
    currentVariantInfo = productsMap[currentVariantInfo];
  }

  useEffect(() => {
    const fetchProductInfo = async (list, cat) => {
      await Promise.allSettled(
        list.map(async (id) => {
          await dispatch(
            getProductInfo({
              id: id,
              cluster: clusterId,
              service: address?.addressSubType || 'DELIVERY',
              categoryId: cat,
              Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
            })
          );
        })
      );
    };

    let product = currentVariantInfo || productsMap[mainProductId];

    let categoryId = product?.level < 2 ? locationSearch.get('option') : product.categories[0];

    // fetch all selected products
    let productIds = [];
    let customization = tempCart?.data?.items?.find((item) => item.id == mainProductId);

    for (let stepInfo of Object.values(customization?.items || customization?.bundle || {})) {
      let productKeys = Object.keys(stepInfo || {});
      productIds = productIds.concat(productKeys);
    }

    console.log(`product -- `, product);
    console.log(`customization -- `, customization);

    fetchProductInfo(productIds, categoryId);
  }, []);

  let variation = variationConfig?.[0]?.variations.filter((v) =>
    title.includes(v[`key_${intl.locale}`])
  );
  if (variation?.length) variation = variation[0];

  const subtitle = variation?.[`subtitle_${intl.locale}`] || '';

  const currentVariantPrice =
    currentVariantInfo?.specialPrice ||
    currentVariantInfo?.originalPrice ||
    currentVariantInfo?.price ||
    0;

  const availableSteps = steps.filter((step) => !step?.isHidden);

  const handleVariantChange = () => {
    setShowBundleGroupDialog(mainProductId);
  };

  const handleBack = () => {
    navigate(-1, {
      state: { oldLocation: location.state },
      replace: true,
    });
  };

  // TODO: Implement Function
  const handleTabSelection = (step) => {
    console.log(`6 setting - `, step);
    setCurrentStepperId((prev) => step);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      setIsSticky(scrollPosition > 100);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const foundIndex = availableSteps.findIndex((step) => step.id == currentStepperId);
    if (foundIndex != -1) {
      setTabIndex(foundIndex);
    }
  }, [currentStepperId, availableSteps]);

  const handleReset = () => {
    let initialStep;
    if (productsMap?.[mainProductId]?.typeId == 'bundle_group') {
      let itemConfig = productsMap?.[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        return (
          itemInfo?.id == locationSearch.get('option') ||
          itemInfo?.sel1Value == locationSearch.get('option')
        );
      });

      if (!itemConfig?.id) {
        itemConfig = productsMap[itemConfig];
      }

      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return (itemInfo?.id == optionId || itemInfo?.sel1Value == optionId)
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      initialStep = (bgSteps || itemConfig)?.steps?.filter((step) => !step?.isHidden)?.[0]?.id || 1;
    } else {
      initialStep =
        productsMap?.[mainProductId]?.steps?.filter((step) => !step?.isHidden)?.[0]?.id || 1;
    }

    let selectedBundleId;
    if (productsMap[mainProductId]?.bundleTypeId == 'bundle_group') {
      let currentVariant = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return (
          itemInfo?.id == locationSearch.get('option') ||
          itemInfo?.sel1Value == locationSearch.get('option')
        );
      });
      if (!currentVariant?.id) {
        currentVariant = productsMap[currentVariant];
      }

      selectedBundleId = currentVariant?.id;
    }

    let data = {
      ...productsMap?.[mainProductId],
      category: productsMap?.[mainProductId]?.categories?.[0],
      noIncrement: true,
    };

    if (selectedBundleId) {
      data = {
        ...productsMap?.[selectedBundleId],
        id: mainProductId,
        category: productsMap?.[mainProductId]?.categories?.[0],
        noIncrement: true,
      };

      data['selectedBundleId'] = selectedBundleId;
      data['specialPrice'] = productsMap[selectedBundleId]?.specialPrice || productsMap[selectedBundleId]?.originalPrice;
    }

    dispatch(
      addProductToCustomize({
        productType: productsMap?.[mainProductId].bundleTypeId,
        updatedOn: new Date().getTime(),
        mainProductId: productsMap?.[mainProductId].id,
        data: data,
      })
    );

    if (locationSearch.has('cartId')) {
      let cartItem = cart.data.items[locationSearch.get('cartId')];
      let qty = cartItem?.qty;
      dispatch(
        increaseQtyByN({
          data: {
            id: data?.id,
            qty: qty,
          },
        })
      );
    }

    console.log(`7 setting - `, initialStep);
    setCurrentStepperId((prev) => initialStep);
    console.log(`7 unlockedStepperId - `, initialStep);
    window.localStorage.setItem('unlockedStepperId', initialStep);
  };

  useEffect(() => {
    return () => {
      if (localStorage.getItem('isBackNotPressed')) {
        localStorage.setItem('isBackNotPressed', false);
      }
    };
  }, []);

  let currentVariationInfo = productsMap[mainProductId]?.variants?.[0]?.options.find(
    (option) => option?.id == locationSearch.get('option')
  );

  return (
    <>
      {!isDesktop && (
        <>
          <div className={isSticky ? css.stickyheader : css.mobHeader}>
            <div className={css.backButton}>
              <BackButton handleBack={handleBack} />
            </div>
            <div className={css.stickyHeader}>
              <span className={css.stickyHeaderTitle}>{title}</span>
              <Button
                className={css.mobileResetBtn}
                size={intl.locale == 'en' ? 'small' : 'large'}
                color="secondary"
                variant="outlined"
                onClick={handleReset}
              >
                <FormattedMessage id={'customize_reset'} defaultMessage={'customize_reset'} />
              </Button>
            </div>
          </div>
          <div className={css.dealHeaderMobile}>
            <img
              src={productsMap?.[mainProductId]?.assets?.[0]?.src}
              alt={title}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImg;
              }}
            />
            <Button
              className={css.stickyResetBtn}
              size={intl.locale == 'en' ? 'small' : 'large'}
              color="secondary"
              variant="outlined"
              onClick={handleReset}
            >
              <FormattedMessage id={'customize_reset'} defaultMessage={'customize_reset'} />
            </Button>
            <div className={css.dealHeaderTitle}>
              {title}
              {(productsMap[mainProductId]?.bundleTypeId == 'bundle_group' &&
                !productsMap[mainProductId]?.isBOGO) && (
                  <div className={css.selectedBundlePrice}>
                    {`${decimalChecker(currentVariantPrice, decimalPoints)} ${
                      countryValidations.currency
                    }`}
                  </div>
                )}
            </div>
            {!productsMap[mainProductId]?.isBOGO && (
              <div className={css.dealHeaderDesc}>{description}</div>
            )}
            {productsMap[mainProductId]?.bundleTypeId == 'bundle_group' && (
              <>
                <div className={css.dealSizeSelector}>
                  {productsMap[mainProductId]?.isBOGO && (
                    <p>{intl.formatMessage({ id: 'deal_size' })}</p>
                  )}
                  <div className={css.currentVariantInfo}>
                    <div className={css.column1}>
                      <img
                        className={css.currentVariationImg}
                        src={currentVariantInfo?.assets?.[0]?.src}
                        alt={`${currentVariantInfo?.assets?.[0]?.assets}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImg;
                        }}
                      />
                      <div className={css.currentVariationDetails}>
                        <p className={css.variationName}>
                          <span>{currentVariationInfo?.title}</span>
                          {subtitle && (
                            <span className={css.variationSubtitle}>{`(${subtitle})`}</span>
                          )}
                        </p>
                        {currentVariantPrice > 0 && (
                          <p className={css.variationPrice}>
                            <span className={css.price}>{decimalChecker(currentVariantPrice)}</span>
                            {` `}
                            <span className={css.currency}>{countryValidations.currency}</span>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={css.column2} onClick={() => handleVariantChange()}>
                      <span className={css.changeBtn}>
                        {intl.formatMessage({ id: 'navigation_change' })}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
      <div className={classNames(css.desktopHeader, css.centerFlex)}>
        <div className={css.dealsWrapper}>
          <div className={css.productInfo}>
            <span onClick={() => navigate(-1)}><MdKeyboardArrowLeft className={css.leftIcon} /></span>
            <h1 className={css.productTitle}>{title}</h1>
            {price > 0 && (
              <>
                <Divider orientation={'vertical'} flexItem={true} />
                <span className={css.productPrice}>{decimalChecker(price, decimalPoints)}</span>
                <span
                  className={css.productPriceCurrency}
                >{` ${countryValidations.currency}`}</span>
              </>
            )}
          </div>

          <Tabs
            variant="scrollable"
            scrollButtons={isDesktop ? 'on' : 'off'}
            value={tabIndex}
            index={tabIndex}
            className={css.tabsBar + ' ' + (intl.locale == 'ar' ? css.reverse : '')}
          >
            {availableSteps.map((step, index) => {
              const productCustomization = tempCart?.data?.items?.find(
                (item) => item.id == mainProductId
              );

              let customizationItem = productCustomization?.['bundle'];
              if (productsMap[mainProductId]?.typeId == 'simple') {
                customizationItem =
                  productCustomization?.['items'] || productCustomization?.['bundle'];
              }

              let addedItems = [];
              for (let [key, obj] of Object.entries(customizationItem?.[step?.id] || {})) {
                if (!obj?.notAdded) {
                  addedItems.push(key);
                }
              }

              let productInfo = null;
              let additionalPrice = 0;

              let notAdded = false;

              if (addedItems.length) {
                let stepInfo;
                if (
                  productsMap[mainProductId]?.isBOGO ||
                  productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
                ) {
                  const optionId = parseInt(locationSearch.get('option'));

                  let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
                    let itemInfo;
                    if (!item?.id) {
                      itemInfo = productsMap[item];
                    } else {
                      itemInfo = item;
                    }

                    return (itemInfo?.id == optionId || itemInfo?.sel1Value == optionId)
                  });
                  if (!bgSteps?.id) {
                    bgSteps = productsMap[bgSteps];
                  }
                  if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
                    bgSteps = productsMap[bgSteps?.id];
                  }
                  stepInfo = bgSteps?.steps?.find((s) => s?.id == step?.id);
                } else {
                  stepInfo = productsMap[mainProductId]?.steps?.find((s) => s?.id == step?.id);
                }

                for (let i = 0; i < addedItems.length; i++) {
                  productInfo =
                    stepInfo?.options?.find((option) => option?.id == addedItems[i]) ||
                    productsMap[addedItems[i]];

                  notAdded = customizationItem?.[step?.id][addedItems[i]]['notAdded'] || false;

                  const productID = productInfo?.id;
                  let currentVariation, currentProductVariation;
                  let variationArray = [-1, -1, -1];
  
                  if (customizationItem?.[step.id]?.[productID]?.variants) {
                    Object.values(customizationItem?.[step.id]?.[productID]?.variants).forEach(
                      (variant, index) => {
                        variationArray[index] = variant;
                      }
                    );
                  } else {
                    Object.values(productInfo?.variants || {}).forEach((variant, index) => {
                      const selectedOption = variant?.options?.find(
                        (option) => option?.isSelected == 1
                      );
                      if (selectedOption) {
                        variationArray[index] = selectedOption?.id;
                      }
                    });
                  }
  
                  if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
                    currentProductVariation = productInfo?.items?.[0] || productInfo;
                  } else {
                    currentProductVariation = productInfo?.items?.find((item) => {
                      let isVariantSame = true;
                      variationArray.forEach((variant, index) => {
                        if (item[`sel${index + 1}Value`] != variant) {
                          isVariantSame = false;
                        }
                      });
                      return isVariantSame;
                    });
                  }
  
                  if (!currentProductVariation?.steps?.options) {
                    currentProductVariation =
                      productsMap[productInfo?.id]?.items?.find(
                        (item) => item.id == (currentProductVariation?.id || currentProductVariation)
                      ) || currentProductVariation;
                  }
  
                  additionalPrice +=
                    currentProductVariation?.price >= 0
                      ? currentProductVariation?.price
                      : currentProductVariation?.specialPrice ||
                        currentProductVariation?.originalPrice ||
                        0;

                  additionalPrice =
                    additionalPrice * (customizationItem?.[step.id]?.[productID]?.['qty'] || 1);

                  for (let variationStep of currentProductVariation?.steps || []) {
                    for (let option of variationStep?.options || []) {
                      if (option?.subOptions) {
                        additionalPrice +=
                          option?.subOptions[
                            customizationItem?.[step.id]?.[productID]?.items?.[variationStep.id]?.[
                              option.id
                            ]?.['qty'] - 1
                          ]?.price || 0;
                      } else {
                        if (
                          customizationItem?.[step.id]?.[productID]?.items?.[variationStep.id]?.[
                            option.id
                          ]?.['qty']
                        ) {
                          additionalPrice +=
                            (option?.price || 0) *
                            Number(
                              customizationItem?.[step.id]?.[productID]?.items?.[variationStep.id]?.[
                                option.id
                              ]?.['qty'] || 0
                            );
                        }
                      }
                    }
                  }
                }
              }

              return (
                <Tab
                  key={`Tab-${index}`}
                  label={
                    productInfo && !notAdded ? (
                      <span className={css.addedProductInfo}>
                        <span className={css.addedProductName}>
                          {productInfo?.name || productInfo?.title}
                        </span>
                        {additionalPrice > 0 && (
                          <span className={css.addedProductPrice}>
                            +{' '}
                            {decimalChecker(additionalPrice, decimalPoints) +
                              ' ' +
                              countryValidations.currency}
                          </span>
                        )}
                      </span>
                    ) : (
                      <>
                        <span className={css.tabsTitle}>{step?.title}</span>
                      </>
                    )
                  }
                  disabled={
                    index != 0 &&
                    step?.id >
                      parseInt(
                        window.localStorage.getItem('unlockedStepperId') || availableSteps[0]?.id
                      )
                  }
                  icon={
                    !productInfo || notAdded ? (
                      <img
                        className={css.categoryTabIcon}
                        src={
                          (productInfo ? productInfo?.assets?.[0]?.src : step?.assets?.[0]?.src) ||
                          noImg
                        }
                        alt={Array.isArray(step?.assets) ? step?.assets[0]?.alt : step?.title}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImg;
                        }}
                      />
                    ) : (
                      <span className={css.addedItemHolder}>
                        <img
                          className={css.addedStepperItem}
                          src={
                            (productInfo
                              ? productInfo?.assets?.[0]?.src
                              : step?.assets?.[0]?.src) || noImg
                          }
                          alt={Array.isArray(step?.assets) ? step?.assets[0]?.alt : step?.title}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = noImg;
                          }}
                        />
                        <TiTick className={css.tickIcon} />
                      </span>
                    )
                  }
                  className={classNames(css.tab, { active: step.id == currentStepperId })}
                  onClick={() => handleTabSelection(step.id)}
                ></Tab>
              );
            })}
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default DealsStepper;
